import { createContext } from 'react';

const RadioTabContext = createContext(null);

export default RadioTabContext;
